/*
 * NLF mobile gallery hints voor de custom .nl-gallery
 *  - Counter "1 / N" pill rechtsboven op de actieve foto
 *  - Eenmalige swipe hint
 *  - Disabled state voor prev/next arrows op eerste/laatste foto
 */
(function () {
  if (typeof window === 'undefined') return;

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function setup() {
    var gallery = document.getElementById('nl-gallery');
    if (!gallery) return;
    if (gallery.dataset.nlfHintsApplied) return;
    gallery.dataset.nlfHintsApplied = '1';

    var main = gallery.querySelector('.nl-gallery__main');
    if (!main) return;

    // Met foto's per variant (#nl-variant-fotos) kan het aantal foto's wisselen,
    // dus dan steeds opnieuw tellen en ook bij 1 foto al opbouwen.
    var wisselbaar = !!document.getElementById('nl-variant-fotos');
    var totalSlides = gallery.querySelectorAll('.nl-gallery__thumb').length;
    if (totalSlides <= 1 && !wisselbaar) return;

    var prevBtn = gallery.querySelector('.nl-gallery__nav--prev');
    var nextBtn = gallery.querySelector('.nl-gallery__nav--next');

    // === Counter pill ===
    var counter = document.createElement('div');
    counter.className = 'nlf-image-counter';
    counter.setAttribute('aria-hidden', 'true');
    main.appendChild(counter);

    function getCurrentIndex() {
      var idx = parseInt(main.getAttribute('data-index'), 10);
      if (isNaN(idx) || idx < 0) idx = 0;
      if (idx >= totalSlides) idx = totalSlides - 1;
      return idx;
    }

    function update() {
      if (wisselbaar) {
        totalSlides = gallery.querySelectorAll('.nl-gallery__thumb').length;
        counter.hidden = totalSlides <= 1;
      }
      var idx = getCurrentIndex();
      counter.textContent = (idx + 1) + ' / ' + totalSlides;
      if (prevBtn) {
        if (idx === 0) prevBtn.classList.add('is-disabled');
        else prevBtn.classList.remove('is-disabled');
      }
      if (nextBtn) {
        if (idx === totalSlides - 1) nextBtn.classList.add('is-disabled');
        else nextBtn.classList.remove('is-disabled');
      }
    }

    update();

    // Observe data-index changes (de bestaande gallery JS update dit)
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === 'data-index') {
          update();
          break;
        }
      }
    });
    observer.observe(main, { attributes: true, attributeFilter: ['data-index'] });
    // Andere fotoreeks na een variantwissel (neverleafs-pdp.js)
    gallery.addEventListener('nlf:galerij-gewisseld', update);

    // === Eenmalige swipe hint ===
    if (!isMobile() || totalSlides <= 1) return;
    var STORAGE_KEY = 'nlf_swipe_hint_seen_v1';
    var seen = false;
    try { seen = !!localStorage.getItem(STORAGE_KEY); } catch (e) {}
    if (seen) return;

    setTimeout(function () {
      main.classList.add('nlf-show-swipe-hint');
      setTimeout(function () {
        main.classList.remove('nlf-show-swipe-hint');
      }, 3600);
    }, 800);

    try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
